import { useCallback } from 'react';
import { map, get } from 'lodash';
import { CHECKED, UNCHECKED } from 'modules/campaigns/config';

const getDataWithUpdatedSelected = ({ data, isSelected, id }) =>
    map(data, entity => {
        if (!id || entity.id === id) {
            return { ...entity, isSelected };
        }
        return entity;
    });

export const useGridRowSelectorHandlers = ({ setData }) => {
    const selectEntity = useCallback(
        data => {
            const id = get(data, 'id');
            setData(prevData => getDataWithUpdatedSelected({ data: prevData, isSelected: CHECKED, id }));
        },
        [setData]
    );
    const unselectEntity = useCallback(
        data => {
            const id = get(data, 'id');
            setData(prevData => getDataWithUpdatedSelected({ data: prevData, isSelected: UNCHECKED, id }));
        },
        [setData]
    );

    const selectAllEntities = useCallback(() => {
        setData(prevData => getDataWithUpdatedSelected({ data: prevData, isSelected: CHECKED }));
    }, [setData]);

    const unselectAllEntities = useCallback(() => {
        setData(prevData => getDataWithUpdatedSelected({ data: prevData, isSelected: UNCHECKED }));
    }, [setData]);

    return {
        selectEntity,
        unselectEntity,
        selectAllEntities,
        unselectAllEntities,
    };
};
